var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"imageWrapper",staticClass:"imgWrapper d-flex",style:({ height: _vm.imageHeight })},[(_vm.imageSrc)?_c('img',{staticClass:"no-flex full-width",class:{
			'is-blurred': !_vm.bypassPreFetch && !_vm.imageSrc
		},attrs:{"src":_vm.imageSrc,"alt":"image"}}):_c('v-progress-circular',{attrs:{"indeterminate":"","size":_vm.isThumb ? 20 : 50,"color":"blue-grey lighten-3"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }